import React, { useEffect, useState } from "react"
import { Box, Stack } from "@mui/material"
import { tokens } from "./theme/tokens"
import screenshot1 from "./images/pngs/screenshot1.jpg"
import screenshot2 from "./images/pngs/screenshot2.jpg"
import screenshot3 from "./images/pngs/screenshot3.jpg"
import screenshot4 from "./images/pngs/screenshot4.jpg"
import screenshot5 from "./images/pngs/screenshot5.jpg"
import screenshot6 from "./images/pngs/screenshot6.jpg"
import screenshot7 from "./images/pngs/screenshot7.jpg"
const screenshots = [screenshot1, screenshot2, screenshot3, screenshot4, screenshot5, screenshot6, screenshot7]

const Screenshot = () => {
  const [activeScreenshot, setActiveScreenshot] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveScreenshot(prev => (prev === screenshots.length - 1 ? 0 : prev + 1))
    }, 3000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])
  return (
    <Box
      sx={{
        maxWidth: 420,
        marginInline: "auto",
        backgroundColor: tokens.colors.background.surface,
        borderRadius: "18px",
        border: `2px solid ${tokens.colors.border}`,
        padding: "1.5rem",
        boxShadow: tokens.shadows.soft
      }}>
      <Box
        component="img"
        src={screenshots[activeScreenshot]}
        alt={`BroStrike app screenshot ${activeScreenshot + 1}`}
        sx={{
          width: "100%",
          borderRadius: "10px",
          border: `1px solid ${tokens.colors.border}`,
          display: "block"
        }}
      />
      <Stack direction="row" spacing={1} alignItems="center" mt={2} justifyContent="center">
        {screenshots.map((_, index) => (
          <Box
            key={`screenshot-dot-${index}`}
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor:
                index === activeScreenshot ? tokens.colors.accent.primary : tokens.colors.background.default,
              border: `1px solid ${tokens.colors.border}`
            }}
          />
        ))}
      </Stack>
    </Box>
  )
}
export default Screenshot
